import { createActions } from "reduxsauce";

// Student Events/Visits (BU-2037). Kept as its own slice rather than folded
// into `events`: the counselor list and this one page independently, hold
// different row shapes, and must not evict each other from the store.
const { Types, Creators } = createActions({
  getStudentEventsFailure: null,
  getStudentEventsRequest: ["params", "resolve", "reject"],
  getStudentEventsSuccess: ["eventsData", "params"],

  getStudentEventFailure: null,
  getStudentEventRequest: ["eventId"],
  getStudentEventSuccess: ["eventData"],

  signUpForEventFailure: null,
  signUpForEventRequest: ["eventId", "eventName"],
  signUpForEventSuccess: ["eventData"],

  withdrawFromEventFailure: null,
  withdrawFromEventRequest: ["eventId", "eventName"],
  withdrawFromEventSuccess: ["eventData"],

  clearStudentEvents: null,
});

export const StudentEventsTypes = Types;
export const StudentEventsCreators = Creators;
